export function hotelSubtitle(hotel) {
  return [hotel.city, hotel.region, hotel.country].filter(Boolean).join(', ')
}

export function applyFilters(hotels, { inEdit, selectBrand, chain, brand, country, query }) {
  const q = query.trim().toLowerCase()
  return hotels.filter((hotel) => {
    if (inEdit && !hotel.inEdit) return false
    if (selectBrand && !hotel.selectBrand) return false
    if (chain && hotel.chain !== chain) return false
    if (brand && hotel.brand !== brand) return false
    if (country && hotel.country !== country) return false
    if (q) {
      const hay = `${hotel.name} ${hotelSubtitle(hotel)} ${hotel.brand} ${hotel.chain}`.toLowerCase()
      if (!hay.includes(q)) return false
    }
    return true
  })
}

export function hotelsInBounds(hotels, bounds) {
  if (!bounds) return hotels
  const { west, east, south, north } = bounds
  const crossesAntimeridian = west > east
  return hotels.filter((hotel) => {
    const latOk = hotel.lat >= south && hotel.lat <= north
    const lngOk = crossesAntimeridian
      ? hotel.lng >= west || hotel.lng <= east
      : hotel.lng >= west && hotel.lng <= east
    return latOk && lngOk
  })
}

export function sortHotels(hotels, sort) {
  const copy = [...hotels]
  if (sort === 'name') {
    copy.sort((a, b) => a.name.localeCompare(b.name))
  } else if (sort === 'city') {
    copy.sort((a, b) => hotelSubtitle(a).localeCompare(hotelSubtitle(b)) || a.name.localeCompare(b.name))
  } else if (sort === 'double-dip') {
    copy.sort((a, b) => Number(b.inEdit && b.selectBrand) - Number(a.inEdit && a.selectBrand) || a.name.localeCompare(b.name))
  }
  return copy
}

export function uniqueSorted(values) {
  return [...new Set(values.filter(Boolean))].sort((a, b) => a.localeCompare(b))
}

export function toGeoJSON(hotels) {
  return {
    type: 'FeatureCollection',
    features: hotels.map((hotel) => ({
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [hotel.lng, hotel.lat] },
      properties: {
        id: hotel.id,
        name: hotel.name,
        inEdit: hotel.inEdit,
        selectBrand: hotel.selectBrand,
        creditKind: hotel.inEdit && hotel.selectBrand ? 'both' : hotel.inEdit ? 'edit' : 'select',
      },
    })),
  }
}

export const PAGE_SIZE = 12
